export const engagementLinkAliasCampaignEmailClickDailyStats =
  "/engagement/link_alias_campaign_email_click_daily_stats/:campaign_id/:mv_id";
